import { StorySettingForm } from './StorySettingForm'
import { withStorySettingForm } from './withStorySettingForm'

const ConnectedStorySettingForm = withStorySettingForm(StorySettingForm)

export { ConnectedStorySettingForm as StorySettingForm }
